'use client';

import { convertElevation } from '@streetferret/geospatial/conversions';
import { formatDistance } from '@streetferret/utils';
import { useUnitPreference } from '../unit-preference';

interface ElevationProps {
  /**
   * Elevation in meters.
   */
  elevation: number;
  /**
   * Number of digits to display after the decimal point.
   * @default 2
   */
  decimals?: number;
}
/**
 * Displays elevation in a human-readable format, converting for the user's unit preference.
 */
export function Elevation({ elevation, decimals = 2 }: ElevationProps) {
  const { unit } = useUnitPreference();

  const convertedElevation = convertElevation(
    elevation,
    'meters',
    unit === 'imperial' ? 'feet' : 'meters',
  );
  const unitNiceName = unit === 'imperial' ? 'ft' : 'm';
  const formattedElevation = formatDistance(convertedElevation, decimals);
  return (
    <div className="tabular-nums inline-flex gap-1">
      <span>{formattedElevation}</span>
      <span>{unitNiceName}</span>
    </div>
  );
}
